export interface IMatchRunSettings {
    bufferDonorAgeByYearsVal: number,
    bufferHlaMatchPointsVal: number,
    onlyPreAcceptedOneWaysVal: boolean,
    ignoreBlockAllDonorsVal: boolean,
    chipsIfFncs3IsLessThan1Val: boolean,
    onlyOtoOVal: boolean,
    maxChainDepthVal: number,
    maxNumberOfClustersVal: number,
    maxLoopDepthVal: number,
    isolateDeepestNVal: number,
    veryLowPmpVal: number,
    lowPmpVal: number,
    cumulativeHlaPointsFloorVal: number,
    onlyOBds: boolean,
    scenario: number,
    chainStarts: number[],
    targetChainEnds: number[],
    centers: number[],
    isFutureScenario: boolean,
    endOnAboO: boolean
}